export const CLIENT_API_ROUTES = {
  // Validation Routes
  VALIDATE_ADMIN_AUTH: `/api/auth/admin/validate-token`,

  // Dashboard
  GET_DASHBOARD_COUNT: `/api/dashboard/count_details`,
  UPDATE_DONATION_SHEET: `/api/dashboard/update-donation-sheet`,

  // Admin Routes
  REGISTER_ADMIN: `/api/admin/register`,
  LOGIN_ADMIN: `/api/admin/login`,
  LOGOUT_ADMIN: `/api/admin/logout`,
  GET_ADMINS: `/api/admin`,
  UPDATE_ADMIN: (adminId) => `/api/admin/${adminId}`,
  DELETE_ADMIN: (adminId) => `/api/admin/${adminId}`,
  ADMIN_CHANGE_PASSWORD: `/api/admin/change_password`,

  //Admin Banner
  CREATE_BANNER: `/api/home/banner`,
  GET_BANNERS: `/api/home/banner`,
  UPDATE_BANNER: (bannerId) => `/api/home/banner/${bannerId}`,
  DELETE_BANNER: (bannerId) => `/api/home/banner/${bannerId}`,

  //Admin Headline
  CREATE_HEADLINE: `/api/headline`,
  GET_HEADLINES: `/api/headline`,
  UPDATE_HEADLINE: (headId) => `/api/headline/${headId}`,
  DELETE_HEADLINE: (headId) => `/api/headline/${headId}`,

  //Admin Popup
  CREATE_POPUP: `/api/home/popup`,
  GET_POPUPS: `/api/home/popup`,
  UPDATE_POPUP: (popId) => `/api/home/popup/${popId}`,
  DELETE_POPUP: (popId) => `/api/home/popup/${popId}`,

  // Admin About
  GET_ABOUT: `/api/about`,
  CREATE_UPDATE_ABOUT: `/api/about`,

  //Admin Mission
  CREATE_MISSION: `/api/about/mission`,
  GET_MISSIONS: `/api/about/mission`,
  UPDATE_MISSION: (id) => `/api/about/mission/${id}`,
  DELETE_MISSION: (id) => `/api/about/mission/${id}`,

  //Admin Vision
  CREATE_VISION: `/api/about/vision`,
  GET_VISIONS: `/api/about/vision`,
  UPDATE_VISION: (id) => `/api/about/vision/${id}`,
  DELETE_VISION: (id) => `/api/about/vision/${id}`,

  //Admin Gallery
  CREATE_GALLERY: `/api/gallery`,
  GET_GALLERY: `/api/gallery`,
  UPDATE_GALLERY: (id) => `/api/gallery/${id}`,
  DELETE_GALLERY: (id) => `/api/gallery/${id}`,

  //Admin Partner Category
  CREATE_PARTNER_CATEGORY: `/api/partner_category`,
  GET_PARTNER_CATEGORIES: `/api/partner_category`,
  UPDATE_PARTNER_CATEGORY: (id) => `/api/partner_category/${id}`,
  DELETE_PARTNER_CATEGORY: (id) => `/api/partner_category/${id}`,

  //Admin Partner
  CREATE_PARTNER: `/api/partner`,
  GET_PARTNERS: `/api/partner`,
  UPDATE_PARTNER: (id) => `/api/partner/${id}`,
  DELETE_PARTNER: (id) => `/api/partner/${id}`,
  GET_PARTNERS_BY_CATEGORY: `/api/partner/category-wise`,

  //Admin Branch
  CREATE_BRANCH: `/api/branch`,
  GET_BRANCHES: `/api/branch`,
  UPDATE_BRANCH: (id) => `/api/branch/${id}`,
  DELETE_BRANCH: (id) => `/api/branch/${id}`,
  SET_HEAD_BRANCH: (id) => `/api/branch/head-branch/${id}`,

  //Admin Service Category
  CREATE_SERVICE_CATEGORY: `/api/service_category`,
  GET_SERVICE_CATEGORIES: `/api/service_category`,
  UPDATE_SERVICE_CATEGORY: (id) => `/api/service_category/${id}`,
  DELETE_SERVICE_CATEGORY: (id) => `/api/service_category/${id}`,

  //Admin Service
  CREATE_SERVICE: `/api/service`,
  GET_SERVICES: `/api/service`,
  UPDATE_SERVICE: (id) => `/api/service/${id}`,
  DELETE_SERVICE: (id) => `/api/service/${id}`,
  GET_SERVICES_BY_CATEGORY: `/api/service/category-wise`,

  GET_SERVICE_SLUG_CATEGORIES: `/api/service/slug-category`,

  //Admin Article
  CREATE_ARTICLE: `/api/article`,
  GET_ARTICLES: `/api/article`,
  UPDATE_ARTICLE: (id) => `/api/article/${id}`,
  DELETE_ARTICLE: (id) => `/api/article/${id}`,
  GET_ARTICLE_BY_SLUG: (slug) => `/api/article/blog/${slug}`,

  //Admin Template
  CREATE_TEMPLATE: `/api/template`,
  GET_TEMPLATES: `/api/template`,
  UPDATE_TEMPLATE: (id) => `/api/template/${id}`,
  DELETE_TEMPLATE: (id) => `/api/template/${id}`,
  GET_TEMPLATE_BY_SLUG: (slug) => `/api/template/page/${slug}`,

  //Admin Contact
  SUBMIT_CONTACT: `/api/contact`,
  GET_CONTACTS: `/api/contact`,
  DELETE_CONTACT: (id) => `/api/contact/${id}`,

  //Admin Career Contact
  SUBMIT_CAREER_CONTACT: `/api/career_contact`,
  GET_CAREER_CONTACTS: `/api/career_contact`,
  DELETE_CAREER_CONTACT: (id) => `/api/career_contact/${id}`,
};
